import './AdminTableError.css'

export const AdminTableError = () => {
    return (
        <div>
            <h1 className="admin-table-error">No Users Found</h1>
        </div>
    )
}